import { Program as ProgramType } from "@platform/types/dashboard.types";
import {
  User as UserType,
  Organization as OrganizationType,
} from "@platform/types/platform.types";
import { ProgramProvider } from "../../ProgramContext";
import { Program } from "./Program";

export type Props = {
  program: ProgramType | null;
  user: UserType | null;
  organization: OrganizationType | null;
};

export function ProgramContainer({ program, user, organization }: Props) {
  return (
    <ProgramProvider>
      <Program program={program} user={user} organization={organization} />
    </ProgramProvider>
  );
}

export default ProgramContainer;
